(function() {
  window.getAddonGroupSubTotal = function(prices,mod,delta) {
    if (!prices || !prices.length) return 0;
    if (!delta) delta = 0;
    if (!mod) {
      prices = prices.map(function(p){return p?p:0;});
      mod = 'SUM_PRICES';
    }
    switch (mod) {
      case 'HIGHEST_PRICE':
        return prices.reduce(function(a,v){return v>a?v:a;},0);
      case 'LOWEST_PRICE':
        return prices.reduce(function(a,v){return v<a?v:a;}, prices[0]);
      case 'SUM_PRICES':
        return prices.reduce(function(a,v){return a+v;},0);
      case 'DELTA_PRICES':
        return prices.map(function(p){return Math.max(0, p-delta);}).reduce(function(a,v){return a+v;},0);
    
      default:
        console.warn('Cannot calculate addons with price modifier:', mod);
        break;
    }
    return 0;
  };

  Array.prototype.mop = function(prop){ // Map tO Prop
    return this.map(function(value){
      return value[prop];
    });
  };

  window.isNumber = function(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  };

  window.testRsaId = function(idNumber) {
    var errors = [];

    idNumber = ''+idNumber;
    //Ref: http://www.sadev.co.za/content/what-south-african-id-number-made
    // SA ID Number have to be 13 digits, so check the length
    if (idNumber.length !== 13 || !window.isNumber(idNumber)) {
      errors.push('input not a valid number');
    }

    // get first 6 digits as a valid date
    var tempDate = new Date(+idNumber.substring(0, 2), idNumber.substring(2, 4) - 1, +idNumber.substring(4, 6));

    var id_date = tempDate.getDate();
    var id_month = tempDate.getMonth();
    var id_year = tempDate.getFullYear();

    //var fullDate = id_date + '-' + (id_month + 1) + '-' + id_year;

    if (!((tempDate.getYear() === +idNumber.substring(0, 2)) && (id_month === idNumber.substring(2, 4) - 1) && (id_date === +idNumber.substring(4, 6)))) {
      errors.push('date part not valid');
    }

    // get the gender
    var genderCode = idNumber.substring(6, 10);
    var gender = parseInt(genderCode) < 5000 ? 'Female' : 'Male';

    // get country ID for citzenship
    var citzenship = parseInt(idNumber.substring(10, 11)) === '0' ? 'Yes' : 'No';

    // apply Luhn formula for check-digits
    var tempTotal = 0;
    var checkSum = 0;
    var multiplier = 1;
    for (var i = 0; i < 13; ++i) {
        tempTotal = parseInt(idNumber.charAt(i)) * multiplier;
        if (tempTotal > 9) {
            tempTotal = parseInt(tempTotal.toString().charAt(0)) + parseInt(tempTotal.toString().charAt(1));
        }
        checkSum = checkSum + tempTotal;
        multiplier = (multiplier % 2 === 0) ? 1 : 2;
    }
    if ((checkSum % 10) !== 0) {
      errors.push('check digit is not valid');
    }
    return errors;
};

})();